import {LoaderStatusValue} from "../../loader/service/loaderStatus";
import {BrandService} from "../../brand_service/service/BrandService";
import {Brand} from "../../brand_service/model/Brand";
import {IPromise, IQService} from "angular";
import './configuration.scss';
import {BrandServiceName} from "../../utils/names/serviceNames";

interface ConfigurationControllerScope {
    updateBrand: (brandId, index) => void;
    colors: string[];
    brands: Brand[];
    brandsPromise: IPromise<Brand[]>;

}

function ConfigurationController($scope: ConfigurationControllerScope,
                                 LoaderService: LoaderStatusValue,
                                 BrandService: BrandService,
                                 $q: IQService,
                                 $mdColorPalette: angular.material.IColorPalette) {

    LoaderService.off();

    $scope.brandsPromise = BrandService.getBrands().then((brandsResp) => {
        let brands = brandsResp.data;
        $scope.brands = brands;
        return brands;
    });
    $scope.colors = Object.keys($mdColorPalette);
    $scope.updateBrand = (brandId, index) => {
        BrandService.updateBrand($scope.brands[index]);
    };
}

export const INSTANCE_CONFIGURATION = ['$scope', 'LoaderStatusValue', BrandServiceName, '$q', '$mdColorPalette', ConfigurationController];